<template>
<v-container fluid class="pa-0">
<v-layout row wrap class="ma-0 mt-2" v-if="!loading.fetchData">
    <v-row no-gutters row wrap class="ma-0 mt-0" v-if="quizItemTree.length > 0" > <!-- quiz-v-card -->
        <!-- Boutons de navigation personnalisés placés AU-DESSUS du carrousel -->
        <div class="custom-carousel-nav">
            <v-btn icon @click="prevSlide" :disabled="carouselModel <= 0" class="nav-btn-left">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span class="nav-counter">{{ carouselModel + 1 }} / {{ validQuizCount }}</span>
            <v-btn icon @click="nextSlide" :disabled="carouselModel >= validQuizCount - 1" class="nav-btn-right">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>
        <v-carousel v-model="carouselModel" height="auto" :continuous="false" :cycle="false" :show-arrows="false" hide-delimiter-background >
        <template v-for="(quizTitle) in quizItemTree">
            <v-carousel-item v-if="quizTitle.qiz_visibility && quizTitle.children && quizTitle.children.length" :key="'id-' + quizTitle.qiz_id">
            <v-card v-if="quizTitle.children && quizTitle.children.length" :class="'card-with-legend mb-0 mt-2'" flat :key="'title-' + quizTitle.qiz_id" color="grey lighten-5">
                <span class="card-legend">{{ quizTitle.qiz_name }}</span>
                <v-row no-gutters row wrap class="ma-0 mt-2" :key="quizTitle.qiz_id + 'row'">
                    <template v-for="(quizItem) in quizTitle.children">
                        <template v-if="quizItem.qiz_visibility">
                            <v-col cols="4" v-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'TITLE'" class="" :key="quizItem.qiz_id">{{ quizItem.qiz_name }}</v-col>
                            <v-col cols="12" v-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'VARCHAR'" class="" :key="quizItem.qiz_id">
                                <v-text-field outlined :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-text-field>
                            </v-col>
                            <v-col cols="4" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'INT'" class="quiz-v-card-numeric" :key="'int-' + quizItem.qiz_id">
                                <v-text-field outlined :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" type="number"></v-text-field>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'RADIO'" class="" :key="'radio-' + quizItem.qiz_id">
                                <v-radio-group v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" >
                                    <v-radio v-for="(radio) in quizItem.children" :key="radio.qiz_id" :label="radio.qiz_name" :value="radio.qiz_id">
                                    <template v-slot:label v-if="typeListById[radio.qiz_typ_id_field].typ_name == 'VARCHAR'">
                                        <v-text-field :title="radio.qiz_id" :label="radio.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-text-field>
                                    </template>
                                    </v-radio>
                                    <!--
                                    -->
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'DATE'" class="pr-2 pl-2" :key="'date-' + quizItem.qiz_id">
                                <DatePicker :label="quizItem.ctp_label" :objectForm="taskItem._pivot['quiz'][quizItem.qiz_id]" fieldName='tqz_txt_value'></DatePicker>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'BOOL'" class="pr-2 pl-2" :key="'bool-' + quizItem.qiz_id">
                                <!-- <p>{{ quizItem.qiz_name }}</p>-->
                                <v-checkbox :title="quizItem.qiz_id" hide-details v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" :label="quizItem.qiz_name"></v-checkbox>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'LIST'" class="pr-2 pl-2" :key="'list-' + quizItem.qiz_id">
                                <v-select v-if="quizItem.qiz_customfields?.list?.length" :title="quizItem.qiz_name" style="z-index: 2000;"
                                    :items="quizItem.qiz_customfields.list"
                                    v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value" :label="quizItem.qiz_name" >
                                </v-select>
                            </v-col>
                        </template>
                    </template>
                    <!-- Spécial adds (not from quizz) -->
                    <template v-if="carouselModel == (validQuizCount - 1)">
                        <v-col  cols="12" class="pr-2 pl-2" :key="'add-1'">
                            <AutocompleteMulti 
                                :title="'Taches à prévoir'" :ressource="'tasktypes'"
                                :listObject.sync="taskActions.tasktypesPrev" :listParent.sync="autoCompleteSource.listTaskTypeItemSource" 
                                :fields="{ 
                                    index: 'tty_id', text:'tty_name', autofocus: true, deletablechips: true,
                                    search:'tty_name', preprendIcon:'', multiSelect:true, prefetch: true, params:'' 
                            }"></AutocompleteMulti>
                        </v-col>
                        <template v-for="item in filteredLivestockTypes">
                        <v-col cols="4" class="pr-1 pl-1" :key="'lst-' + item.typ_id">
                            <v-text-field 
                                outlined :title="item.typ_name" :label="item.typ_name" type="number" v-model="livestockCounts[item.typ_id]"
                                :hint="(taskItem.tsk_customfields.tsk_livestockdiff && taskItem.tsk_customfields.tsk_livestockdiff[item.typ_id]) ? taskItem.tsk_customfields.tsk_livestockdiff[item.typ_id] + '' : ''" persistent-hint>
                            </v-text-field>
                        </v-col>
                        </template>
                        <v-col cols="6">
                            <span>Bon de transhumance</span>
                            <v-switch v-model="taskActions.createAssign" class="mt-0" title="Bon de transhumance" hide-details color="primary" input-value="true"></v-switch>
                        </v-col>
                        <v-col cols="6">
                        <AutocompleteMulti 
                                :title="'Mort(s)'" 
                                :listObject.sync="taskActions.deadLivestock" :listParent.sync="siteItem.livestocks" 
                                :fields="{ 
                                    index: 'lst_id', text:'lst_name', autofocus: true, deletablechips: true,
                                    search:'lst_name', preprendIcon:'', multiSelect:true, prefetch: false, params:'' 
                            }"></AutocompleteMulti>
                        </v-col>
                    </template>
                                       
                </v-row>
            </v-card>
            <!-- <v-system-bar v-else dark style="width: 100%;" class="mb-4" color="primary" :key="'title-emp-' + quizTitle.qiz_id">{{ quizTitle.qiz_name }}</v-system-bar> -->
            </v-carousel-item>
        </template>
        </v-carousel>
    </v-row>
</v-layout>
</v-container>
</template>


<script>
import DatePicker from '@/components/ui/DatePicker'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

import { mapState, mapWritableState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'
import { useTypeStore } from '@/stores/type'
import { useTaskStore } from '@/stores/task'
import { useSiteStore } from '@/stores/site'

export default {
    name: 'task-quiz-edit',
    props: [ 'quiz', 'task' ],
    components: {
        DatePicker, AutocompleteMulti
    },
    computed: {
        ...mapState(useQuizStore, {quizItemList: 'itemList', quizItemTree: 'itemTree' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapWritableState(useTaskStore, { taskItem: 'item', taskActions: 'actions' }),
        ...mapState(useSiteStore,         { siteItem: 'item' }),
        validQuizCount() {
            return this.quizItemTree.filter(item => item.qiz_visibility && item.children && item.children.length > 0).length
        },
        filteredLivestockTypes() {
            return (this.typeListByGroup['LST'] || []).filter(item => item.typ_visibility !== 0);
        },
        livestockDiffs() {
            const diffs = {};
            for (const typId in this.livestockCounts) {
            const initial = this.initialLivestockCounts[typId] || 0;
            const current = Number(this.livestockCounts[typId]) || 0;
                if (current !== initial) {
                    diffs[typId] = current - initial;
                }
            }
            return diffs;
        }
    },
    data: function () {
        return {
            loading : { fetchData: true },         // Enregistrement en cours...
            typPanel: 0,
            radioGroup: null,
            formValues: {},
            carouselModel: 0,
            autoCompleteSource: { listTaskTypeItemSource: [], livestockDead: [] },
            livestockCounts: {}, // current values (bound to fields)
            initialLivestockCounts: {}, // original counts from siteItem
        }
    },
    async mounted (){
        let params = '' //(this.task.tsk_id) ? '&tqz_tsk_id=' + this.task.tsk_id : ''
        await this.quizFetchItems('?per_page=false&qiz_typ_id=QIZ01' + params)
        this.quizItemList.forEach(elem => {
            if( !this.taskItem._pivot['quiz'][elem.qiz_id] ){
                this.taskItem._pivot['quiz'][elem.qiz_id] = { tqz_tsk_id: this.task.tsk_id, tqz_qiz_id: elem.qiz_id, tqz_num_value: 0, tqz_txt_value: null }
            }
          //this.formValues[elem.qiz_id] = { tqz_tsk_id: this.task.tsk_id, tqz_qiz_id: elem.qiz_id, tqz_num_value: null, tqz_txt_value: null }
        })
        if (this.siteItem && Array.isArray(this.siteItem.livestocks)) {
            const counts = {}
            this.siteItem.livestocks.forEach(lst => {
                const typId = lst.lst_typ_id
                counts[typId] = (counts[typId] || 0) + 1
            })
            this.initialLivestockCounts = { ...counts }
            this.livestockCounts = { ...counts }
        }
        this.loading.fetchData = false

    },
    methods: {
        ...mapActions(useQuizStore, { quizFetchItems: 'fetchItems'}),
        nextSlide() {
            if (this.carouselModel < this.quizItemTree.length - 1) {
                this.carouselModel++
            }
        },
        prevSlide() {
            if (this.carouselModel > 0) {
                this.carouselModel--
            }
        },
        getLivestockDiffs() {
            return { ...this.livestockDiffs }
        }
    }
}
</script>

<style>
.quiz-v-card > div {
  border: solid 1px #2daee5 !important;
  border-radius: 24px !important;
  padding: 4px !important;
  margin-bottom: 8px !important;
}

.quiz-v-card-numeric > div {
    padding: 2px !important;
}

.quiz-legend {
  display: block;
  padding: 0 2px 0 6px;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 1.1em;
  color: #333;
}

.card-with-legend {
  position: relative;
  border: 1px solid #3d946d !important;
  border-radius: 8px !important;
}

.card-legend {
  position: absolute;
  top: -12px;
  left: 20px;
  background: white;
  padding: 0 8px;
  color: #3d946d;
  font-weight: bold;
  font-size: 14px;
}

.v-carousel__controls{
    background: #006685 !important;
    height: 28px;
    position: relative;
}

.custom-carousel-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 8px;
  margin-bottom: 4px;
}

.nav-btn-left {
  margin-right: auto;
}

.nav-btn-right {
  margin-left: auto;
}

.nav-counter {
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
</style>